export default {
      id: "requestedChangesPending-usage",
      viewBox: "0 0 22 23",
      url: __webpack_public_path__ + "icons.svg#requestedChangesPending",
      toString: function () {
        return this.url;
      }
    }